import fetchAllCategories from '@dehaat/kisan-app-bl/api/fetchAllCategories';
import { DEFAULT_LANG } from '@dehaat/kisan-app-bl/constants/common';
import { Category } from '@dehaat/kisan-app-bl/models/Product';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import CategoryImageName from '@/components/products/CategoryImageName';
import { LAT_LNG_COOKIE_NAME, VENDOR_ID_COOKIE_NAME, WEBSITE_URL } from '@/constants/common';
interface Props {
  categories: Category[];
}
const CategoriesPage = ({
  categories
}: Props) => {
  const {
    t
  } = useTranslation('main');
  const {
    locale
  } = useRouter();
  const localePrefix = locale === DEFAULT_LANG ? '' : `/${locale}`;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="categories.tsx">
        <title>All Categories | DeHaat Kisan: Agriculture Marketplace</title>
        <meta name="description" content="Shop all agricultural product categories on DeHaat — seeds, fertilizers, pesticides, farm tools, and crop protection solutions for Indian farmers." data-sentry-element="meta" data-sentry-source-file="categories.tsx" />
        <link rel="canonical" href={`${WEBSITE_URL}${localePrefix}/categories`} />
        <link rel="alternate" hrefLang={`${locale}-in`} href={`${WEBSITE_URL}${localePrefix}/categories`} />
      </Head>
      <main className="min-h-screen bg-neutral-10">
        <HeaderWithBackButton heading={t('all_categories')} data-sentry-element="HeaderWithBackButton" data-sentry-source-file="categories.tsx" />
        <section className="bg-white min-h-screen max-w-7xl m-auto px-4 py-20 w-full">
          <div className={categories.length > 0 ? 'grid grid-cols-3 md:grid-cols-6 gap-y-8' : 'text-center'}>
            {categories.length > 0 ? categories.map(category => <div key={category.id}>
                  <CategoryImageName category={category} className="m-auto" />
                </div>) : <span>{t('no_categories')}</span>}
          </div>
        </section>
      </main>
    </>;
};
export const getServerSideProps: GetServerSideProps = async ({
  req: {
    cookies
  },
  locale
}) => {
  const latLng = cookies[LAT_LNG_COOKIE_NAME];
  const vendorId = cookies[VENDOR_ID_COOKIE_NAME];
  const categories = await fetchAllCategories(locale, latLng, vendorId !== 'null' ? vendorId : undefined);
  return {
    props: {
      categories
    }
  };
};
export default CategoriesPage;